export default __webpack_public_path__ + "static/media/target1.3bf0b151.svg";